import { Accordion, AccordionDetails, AccordionSummary, Box, Button, MenuItem, Paper, Select, Slide, TextField, Typography } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as React from 'react';
import TagField from "../../Controls/Fields/tagField";
import _ from 'lodash';
import SelectDefaultEdgeShape from '../Drawer/selectDefaultEdgeShape';
import { StyleShape } from '../../../types';
import { ElementData } from "../../../data/elementData";
import { ElementPropertyNodeImage } from "./elementPropertyNodeImage";


export const ElementProperties = (props) => {
  const [elementDetails, setElementDetails] = React.useState(ElementData);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setElementDetails({
      ...elementDetails,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  

  const handleClose = (e) => {
    props.setOpen(false);
  }

  const handleSave = (e) => {
    props.update(elementDetails);
  }

  // const checkProperty = (propertyName, change) => {
  //   if (!elementDetails[propertyName]) return change;
  //   if (elementDetails[propertyName] === '') return change;
  //   if (props.item[propertyName] && props.item[propertyName] !== elementDetails[propertyName]) {
  //     return true;
  //   }
  //   if (!props.item[propertyName] && elementDetails[propertyName]) {
  //     return true;
  //   }
  //   return change;
  // }

  // React.useEffect(() => {
  //   let change = false;

  //   // if (elementDetails.name != '' && props.item?.name != elementDetails.name) {
  //   //   change = true;
  //   // }
  //   // if (elementDetails.description != '' && props.item?.description != elementDetails.description) {
  //   //   change = true;
  //   // }
  //   // if (elementDetails.firstname != '' && props.item?.firstname != elementDetails.firstname) {
  //   //   change = true;
  //   // }
  //   console.log("asdsadasdassda");
  //   change = checkProperty("name", change);
  //   change = checkProperty("description", change);
  //   change = checkProperty("firstname", change);
  //   change = checkProperty("lastname", change);
  //   change = checkProperty("middlename", change);
  //   change = checkProperty("company", change);
  //   change = checkProperty("position", change);
  //   change = checkProperty("edgetype", change);

  //   if (change) {
  //     console.log("UPDATUJEME");
  //     props.update(elementDetails);
  //   }

  //   // if (!(_.isEqual(elementDetails, props.item))) {
  //   //   props.update(elementDetails);
  //   // }

  //   if (!props.open) {
  //     setElementDetails({
  //       name: '',
  //       description: '',
  //       firstname: '',
  //       lastname: '',
  //       middlename: '',
  //       company: '',
  //       position: ''
  //     });
  //   } else {
  //     setElementDetails({
  //       name: props?.item?.data.name,
  //       description: props?.item?.data.description,
  //       firstname: props?.item?.data.firstname,
  //       lastname: props?.item?.data.lastname,
  //       middlename: props?.item?.data.middlename,
  //       company: props?.item?.data.company,
  //       position: props?.item?.data.position
  //     })
  //   }
  // }, [props.open]);

  React.useEffect(() => {
  //   // setElementDetails({
  //   //   name: props.item.data.name || '',
  //   //   description: props.item.data.description || '',
  //   //   firstname: props.item.data.firstname || '',
  //   //   lastname: props.item.data.lastname || '',
  //   //   middlename: props.item.data.middlename || '',
  //   //   company: props.item.data.company || '',
  //   //   position: props.item.data.position || '',
  //   //   edgetype: props.item.data.edgetype || '',
  //   // })
  console.log(props.item);
    setElementDetails({
      //...elementDetails,
      ...props.item.data
    });
  }, [props.item]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          p: 1,
          width: 350,
          height: "85vh",
          overflowY: "scroll"
        },
      }}
    >
      <Slide direction="right" in={props.open} mountOnEnter unmountOnExit>
        <Paper elevation={5} sx={{ position: "absolute" }}>
          <Box>
            <Button variant="contained" color="success" fullWidth sx={{ my: 0.3 }} onClick={handleSave}>Save</Button>
            <Button variant="contained" color="error" fullWidth sx={{ my: 0.3 }} onClick={handleClose}>Cancel</Button>
          </Box>

          <Box>
            <TextField id="name" name="name" label="Name" size="small" margin="dense" sx={{ width: "100%" }} value={elementDetails.name} onChange={handleChange} />
            <TextField id="description" name="description" label="Description" size="small" margin="dense" sx={{ width: "100%" }} multiline rows={3} value={elementDetails.description} onChange={handleChange} />
            {
              
            props.type === "nodes" ?
            <TextField
              id="template-style-shape"
              select
              label="Shape style"
              size="small"
              margin="dense"
              name="nodeshape"
              defaultValue=""
              value={props.value}
              onChange={handleChange}
              sx={{ width: "100%" }}>
              {StyleShape.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            :<></>
}
          </Box>
          {
            props.type === "nodes" ?
              <>
                <Accordion >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Person</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TextField size="small" margin="dense" name="firstname" label="First name" type="text" fullWidth value={elementDetails?.firstname} onChange={handleChange} />
                    <TextField size="small" margin="dense" name="lastname" label="Last name" type="text" fullWidth value={elementDetails?.lastname} onChange={handleChange} />
                    <TextField size="small" margin="dense" name="middlename" label="Middle name" type="text" fullWidth value={elementDetails?.middlename} onChange={handleChange} />
                    <TextField size="small" margin="dense" name="company" label="Company" type="text" fullWidth value={elementDetails?.company} onChange={handleChange} />
                    <TextField size="small" margin="dense" name="position" label="Position" type="text" fullWidth value={elementDetails?.position} onChange={handleChange} />
                  </AccordionDetails>
                </Accordion>
                <ElementPropertyNodeImage projectId={props.projectId} node={props.item} updateImage={props.updateImage}/>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                    <Typography>Tags</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TagField selectedItem={props.selectedItem} elements={props.elements}></TagField>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                    <Typography>Other</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TextField size="small" margin="dense" name="customfield1" label="Custom field 1" type="text" fullWidth onChange={handleChange} />
                    <TextField size="small" margin="dense" name="customfield2" label="Custom field 2" type="text" fullWidth onChange={handleChange} />
                    <TextField size="small" margin="dense" name="customfield3" label="Custom field 3" type="text" fullWidth onChange={handleChange} />
                  </AccordionDetails>
                </Accordion>
              </> :
              <>
              </>
          }
          {
            props.type === "edges" ?
              <>
                <SelectDefaultEdgeShape handleChange={handleChange} value={"projectData.defaultedgetype"} hideLabel={true} defaultValue={props.projectData.defaultedgetype} />
              </> :
              <>
              </>
          }
        </Paper>
      </Slide>
    </Box>
  );
};